/** date: selection order: date and time, variation and option;
 *
 *  variation: selection order: variation, date and time and option;
 *
 *  quantity: selection order: variation, option and date and time;
 */

import { SupportedCurrencies } from '../supportedCurrencies';

export interface ProductBase {
  name: string;
  type: string;
  currency: SupportedCurrencies;
  productId: string;
  isAvailable?: boolean;
}

export const ProductsTypeEnum = {
  PRODUCT: 'product',
  GIFTCARD: 'giftcard',
} as const;
